import axios from 'axios'

export default {
  getAll() {
    return axios.get('/schools')
      .then(response => (response.data))
  },

  getLeagues(school_id) {
    return axios.get('/schools/' + school_id + '/leagues')
      .then(response => (response.data))
  }
}



// WEBPACK FOOTER //
// ./src/services/Api/SchoolApi.js